const menuItems = [
    {
        title: "yallaLodo",
        link: "/",
        subItems: []
    },
    {
        title: "playstation",
        link: "/",
        subItems: [
            {
                title: "fifa",
                link: "/",
                subItems: [
                    {
                        title: "fifa06",
                        link: "/",
                        subItems: []
                    },
                    {
                        title: "fifa13",
                        link: "/",
                        subItems: [
                            {
                                title: "ronaldo",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "messi",
                                link: "",
                                subItems: []
                            }
                        ]
                    },
                    {
                        title: "fifa23",
                        link: "",
                        subItems: []
                    }
                ]
            },
            {
                title: "GTA",
                link: "",
                subItems: [
                    {
                        title: "GTA13",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "GTA15",
                        link: "",
                        subItems: []
                    }
                ]
            }
        ]
    },
    {
        title: "cards",
        link: "",
        subItems: [
            {
                title: "wildCard",
                link: "",
                subItems: []
            },
            {
                title: "smallCards",
                link: "",
                subItems: [
                    {
                        title: "card1",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "card2",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "card3",
                        link: "",
                        subItems: []
                    }
                ]
            }
        ]
    },
    {
        title: "aboutus",
        link: "",
        subItems: []
    },
    {
        title: "1yallaLodo",
        link: "/",
        subItems: []
    },
    {
        title: "1playstation cards",
        link: "/",
        subItems: [
            {
                title: "1fifa",
                link: "/",
                subItems: [
                    {
                        title: "1fifa06",
                        link: "/",
                        subItems: []
                    },
                    {
                        title: "1fifa13",
                        link: "/",
                        subItems: [
                            {
                                title: "1ronaldo",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "1messi",
                                link: "",
                                subItems: []
                            }
                        ]
                    },
                    {
                        title: "1fifa23",
                        link: "",
                        subItems: []
                    }
                ]
            },
            {
                title: "1GTA",
                link: "",
                subItems: [
                    {
                        title: "1GTA13",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "1GTA15",
                        link: "",
                        subItems: []
                    }
                ]
            }
        ]
    },
    {
        title: "1cards",
        link: "",
        subItems: [
            {
                title: "1wildCard",
                link: "",
                subItems: []
            },
            {
                title: "1smallCards",
                link: "",
                subItems: [
                    {
                        title: "1card1",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "1card2",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "1card3",
                        link: "",
                        subItems: []
                    }
                ]
            }
        ]
    },
    {
        title: "1aboutus",
        link: "",
        subItems: [
            {
                title: "2yallaLodo",
                link: "/",
                subItems: []
            },
            {
                title: "2playstation",
                link: "/",
                subItems: [
                    {
                        title: "2fifa",
                        link: "/",
                        subItems: [
                            {
                                title: "2fifa06",
                                link: "/",
                                subItems: []
                            },
                            {
                                title: "2fifa13",
                                link: "/",
                                subItems: [
                                    {
                                        title: "2ronaldo",
                                        link: "",
                                        subItems: []
                                    },
                                    {
                                        title: "2messi",
                                        link: "",
                                        subItems: []
                                    }
                                ]
                            },
                            {
                                title: "2fifa23",
                                link: "",
                                subItems: []
                            }
                        ]
                    },
                    {
                        title: "2GTA",
                        link: "",
                        subItems: [
                            {
                                title: "2GTA13",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "2GTA15",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "2cards",
                link: "",
                subItems: [
                    {
                        title: "2wildCard",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "2smallCards",
                        link: "",
                        subItems: [
                            {
                                title: "2card1",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "2card2",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "2card3",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "2aboutus",
                link: "",
                subItems: []
            },
            {
                title: "3yallaLodo",
                link: "/",
                subItems: []
            },
            {
                title: "3playstation",
                link: "/",
                subItems: [
                    {
                        title: "3fifa",
                        link: "/",
                        subItems: [
                            {
                                title: "3fifa06",
                                link: "/",
                                subItems: []
                            },
                            {
                                title: "3fifa13",
                                link: "/",
                                subItems: [
                                    {
                                        title: "3ronaldo",
                                        link: "",
                                        subItems: []
                                    },
                                    {
                                        title: "3messi",
                                        link: "",
                                        subItems: []
                                    }
                                ]
                            },
                            {
                                title: "3fifa23",
                                link: "",
                                subItems: []
                            }
                        ]
                    },
                    {
                        title: "3GTA",
                        link: "",
                        subItems: [
                            {
                                title: "3GTA13",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "3GTA15",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "3cards",
                link: "",
                subItems: [
                    {
                        title: "3wildCard",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "3smallCards",
                        link: "",
                        subItems: [
                            {
                                title: "3card1",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "3card2",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "3card3",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "3aboutus",
                link: "",
                subItems: []
            },
            {
                title: "4yallaLodo",
                link: "/",
                subItems: []
            },
            {
                title: "4playstation",
                link: "/",
                subItems: [
                    {
                        title: "4fifa",
                        link: "/",
                        subItems: [
                            {
                                title: "4fifa06",
                                link: "/",
                                subItems: []
                            },
                            {
                                title: "4fifa13",
                                link: "/",
                                subItems: [
                                    {
                                        title: "4ronaldo",
                                        link: "",
                                        subItems: []
                                    },
                                    {
                                        title: "4messi",
                                        link: "",
                                        subItems: []
                                    }
                                ]
                            },
                            {
                                title: "4fifa23",
                                link: "",
                                subItems: []
                            }
                        ]
                    },
                    {
                        title: "4GTA",
                        link: "",
                        subItems: [
                            {
                                title: "4GTA13",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "4GTA15",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "4cards",
                link: "",
                subItems: [
                    {
                        title: "4wildCard",
                        link: "",
                        subItems: []
                    },
                    {
                        title: "4smallCards",
                        link: "",
                        subItems: [
                            {
                                title: "4card1",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "4card2",
                                link: "",
                                subItems: []
                            },
                            {
                                title: "4card3",
                                link: "",
                                subItems: []
                            }
                        ]
                    }
                ]
            },
            {
                title: "4aboutus",
                link: "",
                subItems: []
            }
        ]
    }
];

export default menuItems;
